import common from "../common.js";

export default {
  async deleteRoute(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/routes/${payload.routeId}`;

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });

    context.commit("setResponseCode", response.status);

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }
  },
  async updateRoute(context, payload) {
    const request = {
      routeId: payload.routeId,
      routeName: payload.routeName,
      operators: payload.operators,
      areas: payload.areas,
      products: payload.products,
      sortedOrder: payload.sortedOrder,
      deletedContainers: payload.deletedContainers || [],
    };

    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/routes/${payload.routeId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });

    context.commit("setResponseCode", response.status);

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }
    context.commit("updateRoute", payload);
  },

  async addRoute(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/routes`;

    const request = {
      routeId: payload.routeId,
      routeName: payload.routeName,
      routeInfo: {
        operators: payload.operators,
        areas: payload.areas,
        products: payload.products,
        sortedOrder: payload.sortedOrder,
        deletedContainers: payload.deletedContainers || [],
      },
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });

    context.commit("setResponseCode", response.status);

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();

    payload.routeId = responseJson.routeId;
    context.commit("addRoute", payload);
    context.commit("setCurrentRoute", payload);
  },

  async loadRoutes(context, payload) {
    const responseJson = await common.getRequest(context, payload, "routes");
    const responseData = [];

    for (const key in responseJson) {
      const route = {
        routeId: responseJson[key].routeId,
        routeName: responseJson[key].routeName,
        operators: responseJson[key].operators,
        areas: responseJson[key].areas,
        products: responseJson[key].products,
        numberOfSites: responseJson[key].numberOfSites,
        createdAt: responseJson[key].createdAt,
      };
      responseData.push(route);
    }
    context.commit("setRoutes", responseData);
  },

  async loadRoute(context, payload) {
    const id = payload.routeId;

    let route = {
      routeId: 0,
      routeName: "",
      operators: [],
      areas: [],
      products: [],
      sortedOrder: [],
      deletedContainers: [],
    };

    if (id != 0) {
      const responseJson = await common.getRequest(
        context,
        payload,
        `routes/${id}`
      );
      route = {
        routeId: responseJson.routeId,
        routeName: responseJson.routeName,
        operators: responseJson.operators,
        areas: responseJson.areas,
        products: responseJson.products,
        sortedOrder: responseJson.sortedOrder,
        deletedContainers: responseJson.deletedContainers || [],
      };
    }
    context.commit("setCurrentRoute", route);
  },

  async applySiteFilters(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/routes/apply-filters`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload }),
    });

    context.commit("setResponseCode", response.status);

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();

    context.commit("setFilteredSites", responseJson);
  },
  async loadRouteConfig(context, payload) {
    const responseJson = await common.getRequest(
      context,
      payload,
      "routes/config"
    );
    context.commit("setRouteConfig", responseJson);
  },
};
